import React from "react";
import { InboxCardProps } from "./InboxCard.types";
import {
  Body4MediumTypography,
  Body5MediumTypography,
  Body5RegularTypography,
} from "../../../primitives/Typography/typographyVariants";
import FlexColumn from "../../../components/Layout/FlexColumn/FlexColumn";
import { colorPalette } from "../../../theme/colors";
import FlexRow from "../../../components/Layout/FlexRow/FlexRow";
import Box from "../../../primitives/Box/Box";
import { StyledImage } from "../../../components/Image/Image";
import Tags from "../../../components/Tags/Tags";
import { NumberPill } from "../../../components/NumberPill/NumberPill";
import styled from "@emotion/styled";

const StyledTag = styled(Tags)`
  flex-shrink: 0;
`;
export const InboxCard: React.FC<InboxCardProps> = ({
  title,
  timestamp,
  brandLogo,
  status,
  notificationCount,
  onClick,
  dataCy,
  className,
  draftText,
}) => {
  return (
    <FlexColumn
      onClick={onClick}
      data-cy={dataCy}
      pb={12}
      borderBottom={`1px solid ${colorPalette.popWhite[200]}`}
      className={className}
    >
      <FlexRow py={4} gap={8}>
        <Box
          borderRadius={5}
          overflow="hidden"
          backgroundColor={colorPalette.popWhite[500]}
          height={40}
          width={40}
        >
          <StyledImage
            src={brandLogo}
            alt="Brand logo"
            height="40px"
            width="40px"
            borderRadius="5px"
          />
        </Box>
        <FlexColumn gap={4} flex={1}>
          <FlexRow justifyContent="space-between">
            <Body4MediumTypography
              fontFamily="Lexend"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              maxWidth="82%"
            >
              {title}
            </Body4MediumTypography>
            <Body5RegularTypography color={colorPalette.popBlack[100]}>
              {timestamp}
            </Body5RegularTypography>
          </FlexRow>
          <FlexRow justifyContent="space-between" gap={8}>
            <FlexRow
              gap={8}
              flex={1}
              minWidth={0}
              overflow="hidden"
              alignItems="center"
            >
              <StyledTag
                variant="primary"
                label={status.label}
                icon={status.icon}
                backgroundColor={status.backgroundColor}
                color={status.textColor}
                iconColor={status.iconColor}
                onClick={onClick}
              />
              {draftText && (
                <FlexRow gap={4} flex={1} minWidth={0} overflow="hidden">
                  <Body5MediumTypography
                    color="text.default.secondary"
                    flexShrink={0}
                  >
                    Draft:
                  </Body5MediumTypography>
                  <Body5RegularTypography
                    color={colorPalette.popBlack[100]}
                    textOverflow="ellipsis"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    flex={1}
                    minWidth={0}
                  >
                    {draftText}
                  </Body5RegularTypography>
                </FlexRow>
              )}
            </FlexRow>

            {notificationCount && notificationCount > 0 ? (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                ml="8px"
              >
                <NumberPill value={notificationCount} />
              </Box>
            ) : null}
          </FlexRow>
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  );
};
